/*
 * SKU search fallback for the /search results page.
 * -------------------------------------------------------------------------
 * Shopify's storefront search INDEX does not contain variant SKUs, so a
 * customer who types an exact or partial SKU and presses Enter lands on the
 * "no results" page (Liquid's `search` object can't match SKUs, and no URL
 * option changes that).
 *
 * However, Shopify's PREDICTIVE search API *can* match SKUs when you ask it
 * to, by including `variants.sku` in resources[options][fields]. So when the
 * results page comes back empty, we re-run the same query against predictive
 * search with that field enabled and show the matches.
 *
 * Safe by design:
 *   - Only runs on the search results page (.section-search-template).
 *   - Only runs when the native search returned ZERO products, so normal
 *     keyword searches are never touched or overridden.
 *   - A single match jumps straight to the product (ideal for exact SKUs);
 *     multiple matches (e.g. a SKU prefix shared by several colours) render
 *     as normal product cards in place of the "no results" message.
 */
(function () {
  var section = document.querySelector('.section-search-template');
  if (!section) return;

  var params = new URLSearchParams(window.location.search);
  var terms = (params.get('q') || '').trim();
  if (!terms) return;

  // If the native search already found products, leave everything alone.
  if (section.querySelector('.product-grid .product-block')) return;

  var routes = (window.theme && window.theme.routes) || {};
  var base = routes.base || '';
  var predictivePath = routes.predictiveSearch || '/search/suggest';

  var url = base + predictivePath +
    '?q=' + encodeURIComponent(terms) +
    '&section_id=predictive-search' +
    '&resources[type]=product' +
    '&resources[limit]=12' +
    '&resources[options][unavailable_products]=last' +
    '&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku';

  fetch(url)
    .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
    .then(function (html) {
      var grid = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-grid');
      if (!grid) return;

      var products = grid.querySelectorAll(
        '.product-block:not(.page-block):not(.collection-block)'
      );
      if (!products.length) return;

      // Exact-style lookup: one match -> go straight to the product.
      if (products.length === 1) {
        var link = products[0].querySelector('a[href*="/products/"]');
        if (link) { window.location.href = link.href; return; }
      }

      // Otherwise show the matched products where "no results" was.
      var target = section.querySelector('.filters-adjacent') ||
                   section.querySelector('[data-ajax-container]');
      if (!target) return;

      target.innerHTML = '';
      var heading = document.createElement('h5');
      heading.className = 'align-centre fully-spaced-row';
      heading.textContent = 'Products matching “' + terms + '”';
      target.appendChild(heading);
      target.appendChild(grid);
    })
    .catch(function (e) {
      if (window.console) console.warn('SKU search fallback:', e); // eslint-disable-line no-console
    });
})();
